import styled from 'styled-components';
import { motion } from 'framer-motion';
import { createGradientOrSolid } from 'utils';
import { Gradient } from 'utils/types';
import { SubRollingOfferUiProps } from '../shared/types';
import { containerPadding, maxHeight } from '../shared/utils';

interface HugeRollingOfferProps {
  height: number;
  isPreview: boolean;
}

export interface StyledSubRollingOfferProps extends SubRollingOfferUiProps {
  clickable?: boolean;
}

export const StyledHugeRollingOfferContainer = styled(motion.div)<{
  borderColor: Gradient;
  borderWidth: number;
  marginBottom: number;
  isPreview: boolean;
  backgroundImage?: string;
  backgroundColor: Gradient;
}>`
  min-width: 351px;
  max-height: ${maxHeight}x;
  width: ${({ isPreview }) => (isPreview ? '90%' : '100%')};
  overflow: hidden;
  font-family: var(--font-family);
  border: ${({ borderColor, borderWidth }) =>
    `${borderWidth}px solid ${createGradientOrSolid(borderColor)}`};
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 15px;
  z-index: 1;
  box-sizing: border-box;
  margin-bottom: ${({ marginBottom }) => marginBottom}px;
  background: ${({ backgroundImage, backgroundColor }) =>
    backgroundImage
      ? `url("${backgroundImage}")`
      : createGradientOrSolid(backgroundColor)};
  background-size: 100% 100%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;

  .timer {
    color: white;
    font-size: 18px;
    text-align: center;
    font-weight: 900;
    paint-order: stroke fill;
    -webkit-text-stroke: 1px black;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding-top: 5px;
  }
`;

export const StyledHugeRollingOffer = styled.div<HugeRollingOfferProps>`
  width: 100%;
  height: ${({ height }) => height}px;
  min-height: 176px;
  overflow: ${({ isPreview }) => (isPreview ? 'scroll' : 'hidden')};
  padding: ${containerPadding}px;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 15px;
  z-index: 1;
  box-sizing: border-box;

  .arrow-motion {
    z-index: 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
